import { render } from "./TableSetting.vue?vue&type=template&id=682ba7c6&scoped=true"
import script from "./TableSetting.vue?vue&type=script&lang=js"
export * from "./TableSetting.vue?vue&type=script&lang=js"

import "./TableSetting.vue?vue&type=style&index=0&id=682ba7c6&lang=scss"
import "./TableSetting.vue?vue&type=style&index=1&id=682ba7c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682ba7c6"]])

export default __exports__